import { loading, success, handleErrorException } from 'State/actions';

import * as types from './types';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';

export const getReport = (path, data) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.REPORT_FETCHING, true));
    const response = await MPWWebApi.postGenericInsertUpdate(path, data);
    const report = response.data.Data ? response.data.Data : '';
    dispatch(success(types.REPORT_SUCCESS, report));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.REPORT_ERROR, {
        Title: 'Error',
        Message: 'There was an error retrieving the report',
      })
    );
  } finally {
    dispatch(loading(types.REPORT_FETCHING, false));
  }
};

export const getExcelFile = (path, filename, data) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.REPORT_FETCHING, true));
    await MPWWebApi.postDownloadFile(
      path,
      filename,
      data,
      FileDownloadTypes.ExcelOpenXML
    );
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.REPORT_ERROR, {
        Title: 'Error',
        Message: 'There was an error retrieving the report',
      })
    );
  } finally {
    dispatch(loading(types.REPORT_FETCHING, false));
  }
};

export const clearReport = () => ({
  type: types.REPORT_CLEAR,
});

export const resetError = () => ({
  type: types.REPORT_RESET_ERROR,
});



// WEBPACK FOOTER //
// ./src/state/report/actions.js